/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingsDto } from '../../models/settings-dto';

export interface Settings$Params {}

export function settings(
  http: HttpClient,
  rootUrl: string,
  params?: Settings$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<SettingsDto>> {
  const rb = new RequestBuilder(rootUrl, settings.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingsDto>;
    })
  );
}

settings.PATH = '/users/current/settings';
